import { z } from 'zod';

export default z.object({
  // the base64 encoded data to save
  data: z.string(),
  // the filename to save the file as
  filename: z.string().optional().nullable(),
  // the expected file extension of the file
  extension: z.string(),
});
